import { io, Socket } from 'socket.io-client';
import { SUPPORT_API_BASE } from './support';

let socket: Socket | null = null;

export function getSupportSocket(): Socket {
  if (socket) return socket;

  socket = io(SUPPORT_API_BASE, {
    transports: ['websocket', 'polling'],
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 2000,
    reconnectionDelayMax: 10000,
    timeout: 10000,
  });

  socket.onAny((event, ...args) => {
    console.log('[support-socket] event:', event, args);
  });

  socket.on('connect', () => {
    console.log('[support-socket] connected:', socket?.id);
  });

  socket.on('disconnect', (reason) => {
    console.log('[support-socket] disconnected:', reason);
  });

  socket.on('connect_error', (err) => {
    console.warn('[support-socket] connect_error:', err.message);
  });

  return socket;
}

export function disconnectSupportSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
